import AddIcon from '@mui/icons-material/Add';
import { Fab } from '@mui/material';

interface PageFabProps {
  onClick: () => void;
}

/** The "add" button of a page on a phone, kept just above the bottom navigation. */
export default function PageFab({ onClick }: PageFabProps) {
  return (
    <Fab
      color="primary"
      sx={{
        position: 'fixed',
        bottom:
          'calc(var(--bottom-nav-height) + var(--bottom-nav-inset) + 16px)',
        right: 24,
        zIndex: (theme) => theme.zIndex.speedDial,
      }}
      onClick={onClick}
    >
      <AddIcon />
    </Fab>
  );
}
